import classNames from "classnames";
import AscTabs from "../AscTabs/AscTabs";
import AscCustomSidebar from "./AscCustomSidebar/AscCustomSidebar";
import { data, sidebarData } from "./AscNotesProps";
import styles from "./AscNotes.module.scss";

export interface AscNotesProps {
  className?: string;
}

export default function AscNotes({ className }: AscNotesProps) {
  return (
    <div
      data-testid="asc-notes"
      className={classNames(styles.ground, className)}
    >
      <AscTabs className={styles.tabs} fullWidth={true}>
        {data.map((tab, value) => (
          <AscTabs.Tab
            key={tab.id}
            id={tab.id}
            title={tab.title}
            className={styles.tab}
          >
            <AscCustomSidebar>
              {sidebarData[value].map((item) => (
                <AscCustomSidebar.Item
                  key={item.id}
                  id={item.id}
                  name={item.title}
                  date={item.date}
                  children={item.content}
                />
              ))}
            </AscCustomSidebar>
          </AscTabs.Tab>
        ))}
      </AscTabs>
    </div>
  );
}
